import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=a482ac16&scoped=true&"
import script from "./Instructor.vue?vue&type=script&lang=js&"
export * from "./Instructor.vue?vue&type=script&lang=js&"
import style0 from "./Instructor.vue?vue&type=style&index=0&id=a482ac16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a482ac16",
  null
  
)

component.options.__file = "Instructor.vue"
export default component.exports